import { render } from "./TSMCheckingPage.vue?vue&type=template&id=2b3b5de4"
import script from "./TSMCheckingPage.vue?vue&type=script&lang=js"
export * from "./TSMCheckingPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__